module.exports = __webpack_public_path__ + "img/library.be5030ca.webp";